import { Component } from '@angular/core';

@Component({
  selector: 'app-dot-spinner',
  templateUrl: './dot-spinner.component.html',
  styleUrl: './dot-spinner.component.scss',
})
export class DotSpinnerComponent {}
